module.exports = __webpack_public_path__ + "static/media/youtube.054fc019.svg";